// The issue's floors and its task's title are the mobile app's too.
export { formatIssueLocations, linkedTaskTitle } from '@d-orca/shared/client/issues';
import type { IMinimizedProfession, IProfession } from '@d-orca/shared/trusstor';
import type { IOptionChip } from '@components/Pages/AnalyticsPage/analytics.types';

/** The site catalog's entry for an issue's profession — by id, else by trade. */
export function findCatalogProfession(
  profession: IMinimizedProfession,
  catalog: readonly IProfession[],
): IProfession | undefined {
  return catalog.find((entry) => (profession._id && entry._id === profession._id) || entry.tradeId === profession.tradeId);
}

/**
 * Resolve a profession chip from a minimized profession + site-professions
 * catalog. Returns undefined when `profession.tradeId` is missing or when the
 * catalog entry has no `backgroundColor` (so callers skip rendering the chip
 * rather than showing an unreadable white-on-gray fallback).
 */
export function resolveProfessionChip(
  profession: IMinimizedProfession | undefined,
  catalog: IProfession[],
  tradeName: (tradeId: string) => string,
): IOptionChip | undefined {
  if (!profession?.tradeId) return undefined;
  const background = findCatalogProfession(profession, catalog)?.backgroundColor;
  if (!background) return undefined;
  return {
    background,
    text: tradeName(profession.tradeId),
    tradeId: profession.tradeId,
  };
}
